module.exports = __webpack_public_path__ + "static/media/r12.27be663f.jpg";